module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point03_02_spectacular_spot-86951ceefd7856affc4c167e7bea03b2.jpg";